module.exports = __webpack_public_path__ + "img/Murmeli5.b014b7d6.gif";